import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import RegulationDocumentItem from 'components/Dashboard/Regulations/RegulationDocumentItem';
import { store } from 'components/Store';

const RegulationsDocumentsTab = ({ documents, scrollbarRef }) => {
  const documentsList = documents ?? [];
  const { dispatch } = useContext(store);
  const location = useLocation();

  const rememberDocketPosition = () => {
    dispatch({
      type: 'MODIFY_SECTION',
      parameter: 'clickedOnContentUrl',
      value: `${location.pathname}${location.search}${location.hash}`,
    });
    dispatch({
      type: 'MODIFY_SECTION',
      parameter: 'regulationDocketScrollPosition',
      value: scrollbarRef?.current?.view?.scrollTop ?? 0,
    });
  };

  return (
    <>
      <ul className='policy-list px-0 items-list pb-2 all-open-consultations'>
        {documentsList.map((item, index) => (
          <RegulationDocumentItem
            key={item.id}
            listRow={{
              listContext: {
                index,
                array: documentsList,
                item: {
                  ...item,
                  objectID: item.objectID ?? item.objectId,
                  type: item.type ?? item.objectType ?? 'RegulationDocument',
                  contentUrl: item.contentUrl ?? item.canonicalUrl,
                },
              },
              interactions: {
                itemOnclick: rememberDocketPosition,
              },
            }}
          />
        ))}
      </ul>
      {documentsList.length === 0 && <p className='mb-0'>No docket documents found.</p>}
    </>
  );
};

export default RegulationsDocumentsTab;
